/**
 * The number on file, marked when the client has proved it is theirs.
 *
 * verifiedMobileNo holds the number a code was actually delivered to and answered
 * from, rather than a flag, so correcting the profile silently drops the mark instead
 * of leaving a stale yes behind it. Returns the plain string when unverified, so a
 * profile that has never been verified renders exactly as it always did.
 */
const digits = (value) => String(value || "").replace(/\D/g, "");

export const isMobileVerified = (userDetails) => {
    const onFile = digits(userDetails?.completedMobileNo);
    const proven = digits(userDetails?.verifiedMobileNo);

    return !!onFile && onFile === proven;
};

// the mark on its own, for the places that format the number themselves
export const verifiedMark = (userDetails, t) =>
    isMobileVerified(userDetails) ? (
        <span
            style={{
                marginLeft: 6,
                fontSize: 11,
                color: "#52c41a",
                whiteSpace: "nowrap",
            }}
        >
            ✓ {t("user.mobileVerified", {defaultValue: "Verified"})}
        </span>
    ) : null;

export const renderMobile = (userDetails, t) => {
    const number = userDetails?.completedMobileNo || "";

    if (!number || !isMobileVerified(userDetails)) {
        return number;
    }

    return (
        <span>
            {number}
            {verifiedMark(userDetails, t)}
        </span>
    );
};
